import React, { useState } from 'react'
import "./BillingSetting.css"
import UserNav from '../../components/user_nav/UserNav'
import SettingSideBar from './SettingSideBar'
import IQTextboxLabel from '../../components/util_component/iq_textbox_label/IQTextboxLabel'

function BillingSetting() {
    const [text, setText] = useState("");
    return (
        <div className='billing_setting'>
            <UserNav />
            <div className='billing_setting__container'>
                <SettingSideBar tab={"5"} />
                <div className='billing_setting__main'>
                    <div className='billing_setting__part'>
                        <h5>Billing Details</h5>
                        
                        <div className='billing_setting__inputs'>
                            <div className='billing_setting__inputs_sets'>
                                <IQTextboxLabel label='Name on Card' value={text} setText={() => setText()} placeholder={"First Name"} />
                                <IQTextboxLabel label='Card Number' value={text} setText={() => setText()} placeholder={"Last Name"} />
                            </div>
                            <div className='billing_setting__inputs_sets'>
                                <IQTextboxLabel label='Expiry Date' value="jhone@gmail.com" disabled={true} />
                                <IQTextboxLabel label='CVV' value={text} setText={() => setText()} placeholder={"First Name"} />
                            </div>
                        </div>
                        <button className='billing_setting__btn'>Update</button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default BillingSetting